import { apiService } from '../../../shared/services/apiServices';
import technicianEndpoints from './technicianEndpoints';
import {
  UpdateTechnicianRequest,
  UpdateTechnicianResponse,
  MediaResource,
} from '../types/editTechnicianType';
import { TECHNICIAN_ERROR_MESSAGES } from '../errors';

const ERROR_MESSAGES = TECHNICIAN_ERROR_MESSAGES;

export const editTechnicianApiService = async (
  id: string,
  payload: UpdateTechnicianRequest,
  profile?: MediaResource,
  docs?: MediaResource[]
): Promise<UpdateTechnicianResponse> => {
  const url = `${technicianEndpoints.TECHNICIANS}/${id}`;

  try {
    const requestBody: UpdateTechnicianRequest = { ...payload };

    if (profile) {
      requestBody.profile = profile;
    }

    if (docs && docs.length > 0) {
      requestBody.docs = docs;
    }

    const result = await apiService.patchAPI(url, requestBody);

    if (result.error) {
      throw new Error(
        result.isNetworkError
          ? ERROR_MESSAGES.NETWORK_ERROR
          : ERROR_MESSAGES.UNEXPECTED_ERROR
      );
    }

    return result.data as UpdateTechnicianResponse;
  } catch (_error) {
    throw new Error(ERROR_MESSAGES.UNEXPECTED_ERROR);
  }
};
